/* eslint react/forbid-prop-types: 0 */
/* global globals, translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import MemberStore from '../../stores/MemberStore';
import MembersBlockItem from '../member/MembersBlockItem';

const HighlightPaymentSummary = (props) => {
  const member = get(globals, 'payments.highlightMember');
  if (!member) {
    return null;
  }
  MemberStore.addMember(member);

  const { data } = props;

  return (
    <div className="paymentOption-summary">
      <div className="paymentOption-smallText mbm">
        {get(translations, 'txt: Izcel savu profilu', 'Izcel savu profilu')}
      </div>
      <div className="paymentContainer-member">
        <MembersBlockItem
          member={member}
          imageType="xm"
          customLinkClass="member member--xm"
          hideAnswerScore
          hideAge
          hideLocation
          hideMenu
          hideIcons
          hideVerificationBadge
        />
      </div>
      <div className="paymentOption-line" />
      <div className="paymentOption-bigText">{data.termText}</div>
      <div className="paymentOption-line" />
      <span className="paymentOption-amount">
        <span className="paymentOption-bigText">{data.amountToPay.toFixed(2)}</span>
      </span>
      <span className="paymentOption-smallText">{` ${get(globals, 'currency', '')}`}</span>
      <div className="paymentOption-smallText">{get(translations, 'txt: apmaksai', 'apmaksai')}</div>
    </div>
  );
};

HighlightPaymentSummary.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

export default HighlightPaymentSummary;
